// ANGULAR DEPENDENCY
import { Injectable } from '@angular/core';

// NGRX AND RXJS
import { Store } from '@ngrx/store';

// GLOBAL ACTIONS, SELECTORS AND STATES
import { State } from '../../root-state';
import * as actions from './store/actions';

// COMMON INTERFACES
import { ApiPayload } from '../../../models/common/api/api-payload.interface';

@Injectable()
export class DashBoardStoreService {

  constructor(
    protected store: Store<State>,
  ) {
  }

  /************** Dispatchers ************** */

  // -------------------------------
  //  Dispatch task common
  // -------------------------------
  dispatchDashboardCommon(payload: ApiPayload) {
    this.store.dispatch(new actions.DashboardCommonAction(payload));
  }

}
